export default {"src":"/_next/static/media/teenyicons_floorplan.33abdebe.svg","height":121,"width":121,"blurWidth":0,"blurHeight":0};